import { Button } from '@material-ui/core';
import * as React from 'react';
export default {
  Button,
  React
};